import React, { useEffect } from 'react';
import { useCartContext } from '@context/CartContext';
import { useStoreOutlet } from '@state/useStoreOutlet';
import { useStoreAppColor } from '@state/useStoreAppColor';
import { useStoreSettings } from '@state/useStoreSettings';
import { useStoreViewBill } from '@state/useStoreViewBill';

const XenditPaymentDialog = () => {
  console.log('show dialog xendit-------');
  
  const { getContextState, setConfirmPaymentXendit, setContextState } = useCartContext();
  const xenditPayment = getContextState('confirmPaymentXendit');
  const { outlet: outletInfo } = useStoreOutlet(state => ({ outlet: state.outlet }));
  const { appColor } = useStoreAppColor(state => ({ appColor: state.appColor }));
  const { getSetting } = useStoreSettings(state => ({ getSetting: state.getSetting }));
  const { updateViewBillId } = useStoreViewBill(state => ({ updateViewBillId: state.updateViewBillId }));

  const handleCloseModal = () => {
    setConfirmPaymentXendit(false);
    window.parent.postMessage(false, import.meta.env[`VITE_REACT_APP_DOMAIN_CONTAINER_${import.meta.env.MODE}`]
    );
  };

  const setPostMessageServer = () => {
    const receiveMessage = (event) => {
      if (event.origin === import.meta.env[`VITE_REACT_APP_DOMAIN_CONTAINER_${import.meta.env.MODE}`]) {
        console.log(event)
        if (event.data.key === "close") {
          handleCloseModal();
        } else if (event.data.key === "xendit") {
          // Handle payment result from container
          if (event.data.message.status === "PAID") {
            // Payment success - show confirmation modal
            const transactionId = xenditPayment.data?.result?.external_id?.split('_')[0];
            if (transactionId) {
              updateViewBillId(transactionId);
            }

            setContextState({
              confirmModal: {
                visible: true,
                orderMethod: getSetting().orderMethod,
                parameter: ''
              }
            });
          }
          handleCloseModal();
        }
      }
    };

    window.addEventListener('message', receiveMessage);
  };

  useEffect(() => {
    setPostMessageServer();
    if (xenditPayment && xenditPayment.data) {
      
      // Prepare data to send to container
      const paymentData = {
        show: true,
        type: 'xendit',
        invoiceUrl: xenditPayment.data.invoice_url,
        invoiceId: xenditPayment.data.id,
        externalId: xenditPayment.data.external_id,
        amount: xenditPayment.data.amount,
        currency: xenditPayment.data.currency,
        outletName: outletInfo.outletName,
        color: appColor
      };

      // Send to container via postMessage
      window.parent.postMessage(
        paymentData,
        import.meta.env[`VITE_REACT_APP_DOMAIN_CONTAINER_${import.meta.env.MODE}`]
      );
    }

    // eslint-disable-next-line
  }, []);

  return null; // No UI needed, just communication layer
};

export default XenditPaymentDialog;
